const ModalActions: React.FunctionComponent<React.PropsWithChildren> = ({
  children,
}): JSX.Element => {
  return <div className="mt-3 flex flex-col gap-2 px-8">{children}</div>;
};

export default ModalActions;
